<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>仓库盘点</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 搜索 -->
    <el-card shadow="hover">
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable>
            <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="仓库名">
          <el-input v-model="listQuery.houseName" placeholder="请输入仓库名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-tickets"  v-per="'batchPostStock'" type="primary" plan @click="batchStartComparStock">批量发起盘库</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed="left" />
        <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>
        <el-table-column prop="houseName" label="仓库名称"></el-table-column>
        <el-table-column prop="status" label="当前状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status!=1?'success':''">
              {{scope.row.status | statusFilter}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="cityId" label="城市">
          <template slot-scope="scope">
            {{scope.row.cityId|cityFilter}}
          </template>
        </el-table-column>
        <el-table-column prop="houseName" label="站点"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>

        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

        <el-table-column prop label="操作" fixed="right" width="180px" align="center">
          <template slot-scope="scope">
            <el-button type="text"  v-per="'onePostStock'"  @click="startComparStock(scope.row)" size="mini" icon="el-icon-tickets" v-if="scope.row.status==1">发起盘库</el-button>
            <el-button type="text" @click="handleComparStock(scope.row)" size="mini" class="red" icon="el-icon-s-claim" v-if="scope.row.status==3">去盘库</el-button>
            <el-button type="text" @click="queryComparList(scope.row)" size="mini" icon="el-icon-view">盘库记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
    </el-card>

    <!-- 开始盘库  -->
    <el-dialog :title="title" :visible.sync="comparStockVisible" width="1100px" :close-on-click-modal="false" center>
      <div style="min-height:400px;">
        <el-button type="primary" icon="el-icon-circle-check" style="float:right;margin:5px" @click="stockOneKeyRepair">一键盘平</el-button>
        <!-- 商品列表 -->
        <el-table :data="stockList" border class="table" max-height="320" ref="multipleTable" :row-style="stockGoodsStyle">
          <el-table-column prop="skuCode" label="SKU"></el-table-column>
          <el-table-column prop="skuName" label="商品名称"></el-table-column>
          <el-table-column prop="propertyValue" label="规格"></el-table-column>
          <el-table-column prop="costPrice" label="成本价格"></el-table-column>
          <el-table-column prop="stockNumber" width="80" label="库存数量"></el-table-column>
          <el-table-column prop="stockActualNumber" label="实际盘库数量" width="180">
            <template slot-scope="scope">
              <el-input type="number" placeholder="请输入实际库存" @input="stockActualInput(scope.row)" clearable="" v-model="scope.row.stockActualNumber"> </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="diffType" label="差异类型">
            <template slot-scope="scope">
              <el-select v-model="scope.row.diffType" clearable="" v-if="scope.row.stockNumber!=scope.row.stockActualNumber" placeholder="请选择差异类型">
                <el-option label="丢失" :value="1"></el-option>
                <el-option label="物损" :value="2"></el-option>
                <el-option label="其他原因" :value="3"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="remark" width="200" label="备注">
            <template slot-scope="scope">
              <el-input type="text" placeholder="请输入库存备注" clearable="" v-model="scope.row.remark"> </el-input>
            </template>
          </el-table-column>

        </el-table>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="comparStockVisible=false">取消</el-button>
        <el-button type="info" @click="updateComparStock">提交盘库结果</el-button>
        <el-button type="success" @click="completedComparStock">完成盘库</el-button>
      </span>
    </el-dialog>

    <!-- 盘库批次信息  -->
    <el-dialog title="盘库记录" :visible.sync="comparListVisible" width="1000px" :close-on-click-modal="false" center>
      <div style="min-height:400px;">
        <!-- 商品列表 -->
        <el-table :data="comparList" border class="table" max-height="320">
          <el-table-column prop="batchNo" label="批次"></el-table-column>
          <el-table-column prop="houseName" label="仓库名称"></el-table-column>
          <el-table-column prop="state" width="80" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state!=1?'success':''">
                {{scope.row.state==1?'未开始':scope.row.state==2?"盘库中":"已盘库"}}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="postTime" :formatter="dateFormatA" label="盘库发起时间"></el-table-column>
          <el-table-column prop="postUserName" label="盘库发起人"></el-table-column>

          <el-table-column prop="chargeTime" :formatter="dateFormatA" label="盘库清点时间"></el-table-column>
          <el-table-column prop="chargeUserName" label="盘库清点人"></el-table-column>
          <el-table-column prop label="操作" fixed="right" width="100px" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="queryComparListDetail(scope.row)" size="mini" icon="el-icon-view">盘库详细</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination :total="listQueryComparList.total" :page.sync="listQueryComparList.pageNum" :limit.sync="listQueryComparList.pageSize" @pagination="queryComparList" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="comparListVisible=false">确定</el-button>
      </span>
    </el-dialog>

    <!-- 盘库批次详细库存信息 -->
    <el-dialog title="盘库批次详细记录" :visible.sync="comparListDetailVisible" width="1100px" :close-on-click-modal="false" center>
          <el-form :inline="true" size="small" v-model="listQueryComparListDetail"> 
        <el-form-item label="商品名">
          <el-input v-model="listQueryComparListDetail.skuName" placeholder="请输入商品名" clearable></el-input>
        </el-form-item>
        <el-form-item label="是否存差异">
          <el-select v-model="listQueryComparListDetail.state" clearable placeholder="请选择是否存差异" filterable>
            <el-option  label="未对比" :value="1"></el-option>
            <el-option  label="无差异" :value="2"></el-option>
            <el-option  label="有差异" :value="3"></el-option>
          </el-select>
        </el-form-item> 
       
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="queryComparListDetail(null)">查询</el-button> 
        </el-form-item>
      </el-form>

      <div style="min-height:400px;">
        <el-table :data="comparListDetail" border class="table" max-height="320">
          <el-table-column prop="skuName" label="商品"></el-table-column>
          <el-table-column prop="propertyValue" label="规格"></el-table-column>
          <el-table-column prop="costPrice" label="成本价格"></el-table-column>
          <el-table-column prop="stockNumber" label="库存数"></el-table-column>
          <el-table-column prop="stockActualNumber" label="实际存数"></el-table-column>
           <el-table-column prop="state" label="是否差异">
              <template slot-scope="scope">
                <span v-if="scope.row.state==1">未对比</span>
                <span v-if="scope.row.state==2">无差异</span>
                <span v-if="scope.row.state==3">有差异</span>
              </template>
           </el-table-column>

          <el-table-column prop="diffType" label="存差原因">
               <template slot-scope="scope" v-if="scope.row.state==3">
               <el-tag :type="scope.row.state==3?'success':''">
                {{scope.row.diffType=='1'?'丢失':scope.row.diffType=='2'?"物损":"其他原因"}}
              </el-tag>
              </template>
          </el-table-column>
          <el-table-column prop="createTime"  :formatter="dateFormatA" label="盘点时间"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
        <pagination :total="listQueryComparListDetail.total" :page.sync="listQueryComparListDetail.pageNum" :limit.sync="listQueryComparListDetail.pageSize" @pagination="queryComparListDetail(null)" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="comparListDetailVisible=false">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>


<script>
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";

let vm;
export default {
  components: { Pagination },
  filters: {
    statusFilter(value) {
      const rs = vm.statusList.filter((item) => {
        return item.id === value;
      });

      if (rs != null && rs.length > 0) {
        return rs[0].text;
      }
    },
    cityFilter(value) {
      const rs = vm.cityList.filter((item) => {
        return item.id == value;
      });
      if (rs != null && rs.length > 0) {
        return rs[0].cityName;
      }
    },
  },
  data() {
    return {
      cityList: [],
      listData: [],
      multipleSelection: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        applyCode: "",
        applierName: "",
        houseId: "",
        status: "",
        auditName: "",
      },
      statusList: [
        {
          id: 1,
          text: "正常",
        },
        {
          id: 2,
          text: "停用",
        },
        {
          id: 3,
          text: "盘库中",
        },
      ],
      comparStockVisible: false,
      stockList: [], //仓库库存列表
      title: "",
      comparId: 0, //当前编辑的盘库id
      listQueryComparList: {
        //查询盘库批次信息
        houseId: 0,
        total: 0,
        pageSize: 10,
        pageNum: 1, //当前页
      },
      comparList: [],
      comparListVisible: false, //盘库批次是否可见
      listQueryComparListDetail: {
        //查询盘库批次信息
        houseId: 0,
        state:'',
        skuName:"",
        total: 0,
        pageSize: 10,
        pageNum: 1, //当前页
      },
      comparListDetail: [],
      comparListDetailVisible: false, //盘库批次是否可见
    };
  },
  beforeCreate() {
    vm = this;
  },
  created() {
    this.getAllCity();
    this.querySearch();
  },
  methods: {
    //查询
    querySearch() {
      let temp = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        cityId: this.listQuery.cityId,
        houseName: this.listQuery.houseName,
      };
      wmsApi
        .$axiosGetWmshousePageList(temp)
        .then((res) => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity().then((res) => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    batchStartComparStock() {
      //批量发起盘库
      var houseIdList = [];
      this.multipleSelection.forEach((item) => {
        if (item.status == 1)
          houseIdList.push({ id: item.id, houseName: item.houseName });
      });
      if (houseIdList.length === 0) {
        this.$message.error("请选择至少一个仓库");
        return;
      }

      this.handleStartComparStock(houseIdList);
    },
    startComparStock(row) {
      //单条盘库
      var houseIdList = [{ id: row.id, houseName: row.houseName }];
      this.handleStartComparStock(houseIdList);
    },
    handleStartComparStock(houseList) {
      this.$confirm(
        "确定批量发起盘库吗?发起后，仓库将无法进行出入库操作。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        wmsApi
          .$axiosComparStock({
            houseIdList: houseList,
            userId: globalData.userInfo.id,
            userName: globalData.userInfo.userName,
          })
          .then((res) => {
            this.$message.success("盘库发起成功。请尽快完成盘库以免影响使用。");
            this.querySearch();
          });
      });
    },
    handleComparStock(row) {
      //去盘库
      //1.调用盘口 锁定盘库操作
      //2，获取仓库下的库存信息 填写差异 完成盘库
      wmsApi
        .$axiosComparStart({ houseId: row.id })
        .then((res) => {
          this.getComparStockList(row.id, res.data.data.batchNo);
          this.title = row.houseName + "-库存清单";
          this.comparId = res.data.data.id;
          this.comparStockVisible = true;
        })
        .catch((error) => {
          console.info(error);
          //this.$message.error(error.errmsg);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getComparStockList(hid, batchNo) {
      //获取指定仓库下的库存
      wmsApi
        .$axiosComparStockList({ houseId: hid, batchNo: batchNo })
        .then((res) => {
          this.stockList = res.data.data;
        });
    },
    updateComparStock() {
      //提交盘库结果
      let list = [];
      for (var i = 0; i < this.stockList.length; i++) {
        let goods = this.stockList[i];

        if (
          goods.stockActualNumber != "" &&
          goods.stockActualNumber != goods.stockNumber &&
          (goods.diffType == null || goods.diffType == "")
        ) {
          this.$message.error("商品" + goods.skuName + ",请选择库存差异原因");
          return;
        }

        list.push({
          diffType: goods.diffType,
          id: goods.id,
          remark: goods.remark,
          stockActualNumber: goods.stockActualNumber,
        });
      }

      if (list.length == 0) {
        this.$message.error("请填写库存数");
        return;
      }
      console.info(list);
      let dto = {
        stockList: list,
        comparId: this.comparId,
        updateUserId: globalData.userInfo.id,
        updateUserName: globalData.userInfo.userName,
      };
      wmsApi.$axiosHandleComparStock(dto).then((res) => {
        this.$message.success("商品库存信息提交成功");
      });
    },
    completedComparStock() {
      //完成盘库
      this.$confirm(
        "请仔细核对盘库结果，确认无误后再提交，是否要继续提交完成盘库吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let params = {
          chargeUserId: globalData.userInfo.id,
          chargeUserName: globalData.userInfo.userName,
          comparId: this.comparId,
          remark: "",
        };
        wmsApi.$axiosComplateComparStock(params).then((res) => {
          this.$message.success("盘库成功");
          this.comparStockVisible = false;
          this.querySearch();
        });
      });
    },
    queryComparList(row) {
      //获取盘库记录
      if (row != null) {
        this.listQueryComparList.total = 0;
        this.listQueryComparList.pageNum = 1;
      }
      this.listQueryComparList.houseId = row.id;
      wmsApi.$axiosComparPageList(this.listQueryComparList).then((res) => {
        this.comparList = res.data.data.list;
        this.listQueryComparList.total = res.data.data.total;
        this.comparListVisible = true;
      });
    },
    queryComparListDetail(row) {
        console.info(row)
      if (row != null) {
        this.listQueryComparListDetail.total = 0;
        this.listQueryComparListDetail.pageNum = 1;
        this.listQueryComparListDetail.state='';
        this.listQueryComparListDetail.skuName='';
        this.listQueryComparListDetail.houseId = row.houseId;
        this.listQueryComparListDetail.batchNo = row.batchNo;
      } 
      wmsApi.$axiosComparStockPageList(this.listQueryComparListDetail).then(
        (res) => {
          this.comparListDetail = res.data.data.list;
          this.listQueryComparListDetail.total = res.data.data.total;
          this.comparListDetailVisible = true;
        },
        (err) => {}
      );
    },
    stockOneKeyRepair() {
      //快捷方式 一键将实际库存设置等于现有库存
      this.stockList.forEach((item) => {
        item.stockActualNumber = item.stockNumber;
        item.diffType = "";
      });
    },
    stockActualInput(row) {
      //输入实际库存时，如果实际库存=现有库存 将diffType=''
      if (row.stockActualNumber == row.stockNumber) row.diffType = "";
    },
    stockGoodsStyle({ row, rowIndex }) {
      let rowBackground = {};
      if (row.stockActualNumber != row.stockNumber) {
        rowBackground.background = "#ff7a91";
        return rowBackground;
      }
    },
  },
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>